import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AiMyprCompanyUrlField',
  props: {
    url: null,
    companyName: null,
    industry: null,
    job: null,
    values: null,
    extracting: { type: Boolean },
    extracted: { type: Boolean }
  },
  emits: ["update:url", "update:companyName", "update:industry", "update:job", "update:values", "extract"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:url', value: string): void
  (e: 'update:companyName', value: string): void
  (e: 'update:industry', value: string): void
  (e: 'update:job', value: string): void
  (e: 'update:values', value: string): void
  (e: 'extract'): void
}), expose: any, slots: any, attrs: any }) {

/**
 * 志望動機 AI の応募先 URL + 取得結果編集欄（#append）。
 */




return { __sfc: true,emit }
}

})